<template>
  <v-list-group prepend-icon="mdi-chart-areaspline">
    <template v-slot:activator>
      <v-list-item-title>{{ $t('telemetry') }}</v-list-item-title>
    </template>

    <v-list-item link :to="{ name: 'TelemetryBeverageSales' }" class="ml-2">
      <v-list-item-icon>
        <v-icon>mdi-coffee</v-icon>
      </v-list-item-icon>
      <v-list-item-title>{{ $t('beverageSales') }}</v-list-item-title>
    </v-list-item>

    <v-list-item link :to="{ name: 'TelemetryTotalSales' }" class="ml-2">
      <v-list-item-icon>
        <v-icon>mdi-chart-bar</v-icon>
      </v-list-item-icon>
      <v-list-item-title>{{ $t('totalSales') }}</v-list-item-title>
    </v-list-item>
  </v-list-group>
</template>

<script>
export default {
  name: 'TelemetrySalesList'
}
</script>
